// import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// import {BrowserModule} from '@angular/platform-browser';
// // import {FormsModule, FormControl} from '@angular/forms';
// // import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
//  import {Observable} from 'rxjs/Observable';
//  import {Observer} from 'rxjs/Observer';
// import { FormControl } from '@angular/forms';
import {FormControl} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {NgModule, Component, OnInit, Output, EventEmitter, Input} from '@angular/core';

@Component({
  selector: 'app-accessory-catalog',
  templateUrl: './accessory-catalog.component.html',
  styleUrls: ['./accessory-catalog.component.css']
})

export class AccessoryCatalogComponent implements OnInit {
  externalSearchText: string;
  private searchField: FormControl;
  // @Input()  selectSearch: string;
  @Output() selectSearch = new EventEmitter<string>();
  constructor() {
  }

  // print (): void {
  //   console.log(this.externalSearchText);
  // }

  ngOnInit() {
    this.searchField = new FormControl();
    this.searchField.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(term => {
        this.externalSearchText = this.searchField.value;
        this.selectSearch.emit(this.externalSearchText);
        console.log(this.externalSearchText);
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/configuration/accessory-catalog/accessory-catalog.component.ts